import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const flyers = [
  {
    lang: 'English',
    src: '/assets/images/foodpantry/food-pantry-flyer-english.jpg',
    alt: 'Food Pantry flyer in English. Tomorrow, September 29, 2026, 2:30 to 3:30 PM, in the Main Lobby. A paper grocery bag with a heart holds canned goods, pasta, rice, and peanut butter. Brought to us by our community organization, Global Kids.',
  },
  {
    lang: 'Español',
    src: '/assets/images/foodpantry/food-pantry-flyer-spanish.jpg',
    alt: 'Volante de la Despensa de Alimentos en español. Mañana, de 2:30 a 3:30 p. m., en el vestíbulo principal. Bolsas con verduras, frutas, pan, aceite y alimentos enlatados. Presentado por nuestra organización comunitaria, Global Kids.',
  },
];

const FoodPantryPage = () => (
  <div className="min-h-screen bg-white">
    <Navbar />

    <main id="main-content" className="pt-0">
      {/* Hero */}
      <section className="relative pt-36 pb-20 bg-[#00213a] overflow-hidden">
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0"
          style={{ height: '4rem', background: 'linear-gradient(to bottom, rgba(0,33,58,0) 0%, rgba(255,255,255,1) 100%)' }}
          aria-hidden="true"
        />

        <div className="max-w-6xl mx-auto px-6 lg:px-8 text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
              <span className="text-sm font-semibold text-white tracking-tight">Families</span>
            </div>
          </div>
          <h1 className="text-5xl lg:text-7xl font-semibold text-white mb-6 tracking-tight" style={{ letterSpacing: '-0.02em' }}>
            Food Pantry
          </h1>
          <p className="text-2xl text-white/90 font-normal max-w-3xl leading-relaxed mx-auto">
            Free groceries for PS 96 families, brought to our main lobby by our community partner Global Kids.
          </p>
        </div>
      </section>

      {/* Schedule */}
      <section className="max-w-5xl mx-auto px-6 lg:px-8 mt-12">
        <div className="bg-[#fdbb2e]/10 border border-[#fdbb2e]/30 rounded-xl p-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">Food Pantry Every Tuesday</h2>
          <p className="text-gray-800 text-lg leading-relaxed">
            Starting <strong>Tuesday, October 20</strong>, the food pantry is open <strong>every Tuesday from 2:30 to 3:00 PM</strong> in the main lobby.
          </p>
          <p className="text-gray-700 leading-relaxed mt-2">
            <span lang="es">Despensa de alimentos todos los martes de 2:30 a 3:00 p. m., a partir del martes 20 de octubre.</span>
          </p>
        </div>
      </section>

      {/* Flyers */}
      <section className="max-w-5xl mx-auto px-6 lg:px-8 mt-12 mb-20">
        <h2 className="text-3xl font-semibold text-gray-900 mb-2 tracking-tight" style={{ letterSpacing: '-0.02em' }}>
          September Flyers
        </h2>
        <p className="text-gray-600 mb-8">
          These flyers are from our September food pantry. Select a flyer to view it full size.
        </p>
        <div className="grid md:grid-cols-2 gap-8">
          {flyers.map((f) => (
            <figure key={f.lang} className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
              <a href={f.src} target="_blank" rel="noopener noreferrer" className="block">
                <img src={f.src} alt={f.alt} className="w-full h-auto" loading="lazy" />
                <span className="sr-only">(opens full size in a new tab)</span>
              </a>
              <figcaption className="px-6 py-4 text-sm font-bold uppercase tracking-widest text-[#00213a] border-t border-gray-100">
                {f.lang}
              </figcaption>
            </figure>
          ))}
        </div>
        <p className="text-gray-600 mt-10">
          Learn more about our partner,{' '}
          <a href="/global_kids_inc" className="text-[#00213a] font-semibold underline hover:text-[#003a5d]">Global Kids</a>.
        </p>
      </section>
    </main>

    <Footer />
  </div>
);

export default FoodPantryPage;
